import Link from "next/link";
import type { BriefSummary } from "@/types/DailyBrief";
import { BRIEF_PATH } from "@/lib/briefs/format";
import dictionary from "@/utils/dictionary";
import BriefFolio from "./BriefFolio";
import LinkIcon from "@/assets/vectors/Link";
import styles from "./brief.module.scss";

export default function BriefCard({ brief, featured = false }: { brief: BriefSummary; featured?: boolean }) {
    const copy = dictionary.brief;
    if (featured)
        return (
            <Link href={`${BRIEF_PATH}/${brief.slug}`} className={styles.featured}>
                <BriefFolio date={brief.date} />
                <div className={styles.featured_content}>
                    <span className={styles.eyebrow}>{copy.latest}</span>
                    <h2>{brief.title}</h2>
                    <p>{brief.summary}</p>
                    <div className={styles.card_bottom}>
                        <span>
                            {brief.storyCount} {copy.stories} · {brief.readingMinutes} {copy.minutes}
                        </span>
                        <span className={styles.read}>
                            {copy.read}
                            <LinkIcon aria-hidden="true" />
                        </span>
                    </div>
                </div>
            </Link>
        );
    return (
        <Link href={`${BRIEF_PATH}/${brief.slug}`} className={styles.card}>
            <time dateTime={brief.date} className={styles.row_date}>
                <strong>{brief.date.slice(-2)}</strong>
                <span>
                    {new Intl.DateTimeFormat("en-US", { month: "short", year: "numeric", timeZone: "UTC" }).format(
                        new Date(`${brief.date}T12:00:00Z`)
                    )}
                </span>
            </time>
            <div className={styles.row_content}>
                <h3>{brief.title}</h3>
                <p>{brief.summary}</p>
                <span className={styles.row_meta}>
                    {brief.tags.join(" / ")} · {brief.readingMinutes} {copy.minutes}
                </span>
            </div>
            <LinkIcon className={styles.row_arrow} aria-hidden="true" />
        </Link>
    );
}
